"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSymbolAlign = exports.APIMetaFieldPropertyFormatEnums = exports.APIMetaFieldPermissionLevel = exports.APIMetaMemberType = exports.APIMetaViewType = exports.APIMetaFieldType = void 0;
var APIMetaFieldType;
(function (APIMetaFieldType) {
    APIMetaFieldType["NotSupport"] = "NotSupport";
    APIMetaFieldType["Text"] = "Text";
    APIMetaFieldType["Number"] = "Number";
    APIMetaFieldType["SingleSelect"] = "SingleSelect";
    APIMetaFieldType["MultiSelect"] = "MultiSelect";
    APIMetaFieldType["DateTime"] = "DateTime";
    APIMetaFieldType["Attachment"] = "Attachment";
    APIMetaFieldType["MagicLink"] = "MagicLink";
    APIMetaFieldType["URL"] = "URL";
    APIMetaFieldType["Email"] = "Email";
    APIMetaFieldType["Phone"] = "Phone";
    APIMetaFieldType["Checkbox"] = "Checkbox";
    APIMetaFieldType["Rating"] = "Rating";
    APIMetaFieldType["Member"] = "Member";
    APIMetaFieldType["MagicLookUp"] = "MagicLookUp";
    // RollUp = 'RollUp',
    APIMetaFieldType["Formula"] = "Formula";
    APIMetaFieldType["Currency"] = "Currency";
    APIMetaFieldType["Percent"] = "Percent";
    APIMetaFieldType["SingleText"] = "SingleText";
    APIMetaFieldType["AutoNumber"] = "AutoNumber";
    APIMetaFieldType["CreatedTime"] = "CreatedTime";
    APIMetaFieldType["LastModifiedTime"] = "LastModifiedTime";
    APIMetaFieldType["CreatedBy"] = "CreatedBy";
    APIMetaFieldType["LastModifiedBy"] = "LastModifiedBy";
    APIMetaFieldType["Cascader"] = "Cascader";
})(APIMetaFieldType = exports.APIMetaFieldType || (exports.APIMetaFieldType = {}));
var APIMetaViewType;
(function (APIMetaViewType) {
    APIMetaViewType["Grid"] = "Grid";
    APIMetaViewType["Gallery"] = "Gallery";
    APIMetaViewType["Kanban"] = "Kanban";
    APIMetaViewType["Gantt"] = "Gantt";
    APIMetaViewType["Calendar"] = "Calendar";
    APIMetaViewType["Architecture"] = "Architecture";
})(APIMetaViewType = exports.APIMetaViewType || (exports.APIMetaViewType = {}));
var APIMetaMemberType;
(function (APIMetaMemberType) {
    APIMetaMemberType["Team"] = "Team";
    APIMetaMemberType["Member"] = "Member";
})(APIMetaMemberType = exports.APIMetaMemberType || (exports.APIMetaMemberType = {}));
/**
  * Field Meta describes cell data. Columns can be read, that is, cells can be read. Cell permissions and column permissions are strongly related.
  * Permission level: Manage > Edit > Read
  */
var APIMetaFieldPermissionLevel;
(function (APIMetaFieldPermissionLevel) {
    APIMetaFieldPermissionLevel["Read"] = "Read";
    APIMetaFieldPermissionLevel["Edit"] = "Edit";
    APIMetaFieldPermissionLevel["Manage"] = "Manage";
})(APIMetaFieldPermissionLevel = exports.APIMetaFieldPermissionLevel || (exports.APIMetaFieldPermissionLevel = {}));
var APIMetaFieldPropertyFormatEnums;
(function (APIMetaFieldPropertyFormatEnums) {
    APIMetaFieldPropertyFormatEnums["DateTime"] = "DateTime";
    APIMetaFieldPropertyFormatEnums["Number"] = "Number";
    APIMetaFieldPropertyFormatEnums["Percent"] = "Percent";
    APIMetaFieldPropertyFormatEnums["Currency"] = "Currency";
})(APIMetaFieldPropertyFormatEnums = exports.APIMetaFieldPropertyFormatEnums || (exports.APIMetaFieldPropertyFormatEnums = {}));
var TSymbolAlign;
(function (TSymbolAlign) {
    TSymbolAlign["Default"] = "Default";
    TSymbolAlign["Left"] = "Left";
    TSymbolAlign["Right"] = "Right";
})(TSymbolAlign = exports.TSymbolAlign || (exports.TSymbolAlign = {}));
//# sourceMappingURL=field_api_enums.js.map